import { render, staticRenderFns } from "./base-cascader.vue?vue&type=template&id=2cddd0cf&scoped=true"
import script from "./base-cascader.vue?vue&type=script&lang=js"
export * from "./base-cascader.vue?vue&type=script&lang=js"
import style0 from "./base-cascader.vue?vue&type=style&index=0&id=2cddd0cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cddd0cf",
  null
  
)

export default component.exports